<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ART &HUMANITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Journalism & Mass Communication</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Arts</td>
                            <td class="time">Master of Arts (Journalism & Mass Communication)</td>
                            <td class="time">Ph.D Mass Communication</td>
                            <td class="time">Diploma in Mass communication</td>
                        </tr>
                        <tr>
                            <td class="time">Bachelor of Arts(Journalism and Mass Communication)</td>
                            <td class="time"></td>
                            <td class="time"></td>
                            <td class="time"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Journalism & Mass Communication</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Arts </b>
                    – ARNI School of Art & Humanities offers a comprehensive Bachelor of Arts program, focusing on
                    critical thinking, creative expression, and intellectual development, preparing graduates for
                    diverse fields like education, research, media, and public service.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations of Arts</p>
                <ul>
                    <li> Introduction to Arts and Humanities</li>
                    <li> English Language and Literature I</li>
                    <li> Principles of Sociology</li>
                    <li> Political Science I</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Exploring Society, Culture, and
                    Communication
                </p>
                <ul>
                    <li> Introduction to Psychology</li>
                    <li> History of India I</li>
                    <li> Basic Communication Skills</li>
                    <li> Sociology of Education</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Deepening Knowledge in Core
                    Disciplines
                </p>
                <ul>
                    <li> English Language and Literature II</li>
                    <li> Indian Politics and Governance</li>
                    <li> Research Methodology</li>
                    <li> Contemporary Indian Society</li>
                    <li> Elective III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> :Exploring Arts, Society, and Thought
                </p>
                <ul>
                    <li> Modern European History</li>
                    <li> Philosophy I</li>
                    <li> Cultural Anthropology</li>
                    <li> Developmental Psychology</li>
                    <li> Elective IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Specialization and Practical
                    Applications
                </p>
                <ul>
                    <li> English Literature</li>
                    <li> Political Theory and Thought</li>
                    <li> Sociology of Gender</li>
                    <li> Environmental Studies</li>
                    <li> Elective V</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Integrating Learning and Independent
                    Research
                </p>
                <ul>
                    <li> World Literature</li>
                    <li> Political Economy</li>
                    <li> Social Work and Welfare</li>
                    <li> Elective VI</li>
                    <li> Dissertation/Project</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Arts (Journalism and Mass
                    Communication) </b>
                    – The ARNI School of Art & Humanities offers a Bachelor of Arts in Journalism and Mass Communication
                    program, preparing students for careers in print, electronic, and digital media. The program
                    emphasizes ethical responsibilities for journalists in a rapidly changing media landscape.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Introduction to Journalism and
                    Communication
                </p>
                <ul>
                    <li> Introduction to Journalism</li>
                    <li> Mass Communication Theory</li>
                    <li> English for Media</li>
                    <li> Media and Society</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Understanding Media and Developing
                    Communication Skills
                </p>
                <ul>
                    <li> Print Journalism</li>
                    <li> Radio and Television Journalism</li>
                    <li> Introduction to Photography and Videography</li>
                    <li> Communication Research Methods</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Specialized Journalism and Digital
                    Media
                </p>
                <ul>
                    <li> Digital Journalism</li>
                    <li> Public Relations and Advertising</li>
                    <li> Media Laws and Ethics</li>
                    <li> Writing for Media</li>
                    <li> Elective III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Advanced Journalism and Media
                    Production
                </p>
                <ul>
                    <li> Investigative Journalism</li>
                    <li> Media Production and Direction</li>
                    <li> Media Management and Entrepreneurship</li>
                    <li> Cultural and Social Impacts of Media</li>
                    <li> Elective IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Practical Applications and Industry
                    Exposure
                </p>
                <ul>
                    <li> Broadcast Journalism</li>
                    <li> Magazine and Online Content Production</li>
                    <li> Journalism and Media Ethics</li>
                    <li> Media and Political Communication</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Final Project and Industry
                    Integration
                </p>
                <ul>
                    <li> Digital Media and Content Strategy</li>
                    <li> Dissertation/Research Project</li>
                    <li> Media and Globalization</li>
                    <li> Media Internship/Project</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Arts (Journalism & Mass Communication) </b>
                    – The Master of Arts in Journalism and Mass Communication program at ARNI School of Art & Humanities
                    offers advanced knowledge and skills in journalism, media, and communication. It covers topics like
                    digital media, investigative journalism, media ethics, and public relations, preparing students for
                    leadership roles in the media industry.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations and Advanced Concepts
                    in Media
                </p>
                <ul>
                    <li> Media and Society</li>
                    <li> Advanced Journalism Theory</li>
                    <li> Media Research Methodology</li>
                    <li> Digital Media and Communication</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Specialization and Media Skills
                    Development
                </p>
                <ul>
                    <li> Broadcast Journalism</li>
                    <li> Public Relations and Corporate Communication</li>
                    <li> Investigative Journalism</li>
                    <li> Media Laws and Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Advanced Journalism Practices and
                    Media Production
                </p>
                <ul>
                    <li> Digital Journalism and Content Strategy</li>
                    <li> Media Production and Management</li>
                    <li> International Journalism</li>
                    <li> Advertising and Media Strategies</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Specialized Media Practices and
                    Final Project
                </p>
                <ul>
                    <li> Visual Journalism and Photography</li>
                    <li> Media Entrepreneurship and Innovation</li>
                    <li> Communication Policy and Global Media Systems</li>
                    <li> Dissertation/Research Project</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Mass communication </b>
                    – The Diploma in Mass Communication at ARNI School of Art & Humanities is designed to provide
                    students with fundamental knowledge and practical skills in journalism, digital media, advertising,
                    and public relations. This program is ideal for those seeking a career in media industries,
                    including television, radio, print, and digital platforms. It combines theoretical foundations with
                    hands-on training to prepare students for real-world media challenges.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Introduction to Mass Communication</li>
                    <li> Media and Society</li>
                    <li> Basics of Journalism</li>
                    <li> Introduction to Public Relations and Advertising</li>
                    <li> Reporting and Editing</li>
                    <li> History, Law and Ethics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Public Relations and Advertising</li>
                    <li> Radio and TV Journalism</li>
                    <li> Emerging Social Media</li>
                    <li> Digital Journalism and Social Media</li>
                    <li> Broadcast Journalism (Radio & TV)</li>
                </ul>
            </div>

            <hr class="border-dashed border-2"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Ph.D Mass Communication </b>
                    – The Doctor of Philosophy (Ph.D.) in Mass Communication at ARNI School of Art & Humanities is a
                    research-driven program that aims to develop scholars and professionals with expertise in media
                    studies, journalism, communication theories, digital media, and public discourse. The program
                    emphasizes original research, critical analysis, and theoretical contributions to the evolving
                    landscape of mass communication.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Research Methodology in Mass Communication</li>
                    <li> Advanced Communication Theories</li>
                    <li> Media and Society: A Global Perspective</li>
                    <li> Digital Media Studies</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Media Ethics and Laws in the Digital Age</li>
                    <li> Content Analysis and Media Research Techniques</li>
                    <li> Advanced Public Relations and Strategic Communication</li>
                    <li> Research Proposal Development and Literature Review</li>
                    <li> Elective II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Doctoral Seminar on Emerging Trends in Mass Communication</li>
                    <li> Media Entrepreneurship and Innovation</li>
                    <li> Field Work and Data Collection</li>
                    <li> Elective III</li>
                    <li> Thesis Writing and Research Presentation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> History of Mass Communication and Journalism</li>
                    <li> Advertising & Public Relations</li>
                    <li> Communication Theory</li>
                    <li> Specialized and Analytical Journalism</li>
                    <li> Elective IV</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Theory of Culture and Media</li>
                    <li> Ethical Issues in Journalism</li>
                    <li> Communication Research Methodology</li>
                    <li> Multimedia Journalism</li>
                    <li> Media and Cultural Study</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Contemporary Theory and Issues of Journalism</li>
                    <li> Communication Technologies</li>
                    <li> Editing</li>
                    <li> Law and Ethics of Telecommunication</li>
                    <li> Thesis Writing and Research Presentation</li>
                </ul>
            </div>


        </div>

    </div>
</section>
